import { render, staticRenderFns } from "./AddNewPlan.vue?vue&type=template&id=410cdb7d"
import script from "./AddNewPlan.vue?vue&type=script&lang=js"
export * from "./AddNewPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports